import { ContainerBase } from '@/components/containers/ContainerBase'
import { Box, Stack, Text, useColorModeValue } from '@chakra-ui/react'
import { ReactNode } from 'react'

interface InfoFrameProps {
  title: string
  description: ReactNode
  reverseColors?: boolean
}

export const InfoFrame = ({ title, description, reverseColors = false }: InfoFrameProps) => {
  const color = useColorModeValue('white', 'black')
  const reverseColor = useColorModeValue('black', 'white')
  const bg = useColorModeValue('black', 'white')
  const reverseBg = useColorModeValue('white', 'black')

  return (
    <Box bg={reverseColors ? reverseBg : bg}>
      <ContainerBase
        py={{ base: '32px', md: '100px' }}
        px={{ base: '32px', md: 4 }}
      >
        <Stack
          direction={{ base: 'column', lg: 'row' }}
          color={reverseColors ? reverseColor : color}
          align="center"
          justify="space-between"
          gap={{ base: '16px', md: '64px' }}
        >
          <Text
            fontSize="40px"
            fontWeight="300"
            fontFamily="Space Grotesk"
            maxW="358px"
          >
            {title}
          </Text>
          <Box
            flexShrink={0}
            width={{ base: '100%', lg: '4px' }}
            h={{ base: '4px', lg: 'auto' }}
            alignSelf="stretch"
            bg="gradient.brand"
          />
          <Text fontSize={{ base: '16px', md: '24px' }} maxW="726px">
            {description}
          </Text>
        </Stack>
      </ContainerBase>
    </Box>
  )
}
